import React, { useState, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'; // <--- 1. Importação do i18n
import "./wireCapabilities.css"

// Importando os logos por idioma
import logoPT from "../../imagens/logos/logoWires.png"
import logoEN from "../../imagens/logos/logoWireProductionEn.png"

function WireCapabilities({ listaChicotes }) { 
    // <--- 2. Removi a prop 'language', vamos usar o hook abaixo
    
    const { t, i18n } = useTranslation(); 

    // <--- 3. Lógica para definir qual logo usar
    const logoByLanguage = i18n.language === 'pt' ? logoPT : logoEN;

    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(listaChicotes.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, listaChicotes.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listaChicotes.length
            ? setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listaChicotes.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {
                openModal &&
                <div className="wireSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="wireBtnClose" onClick={handleCloseModal} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="wireBtnPrev" onClick={prevSlide} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="wireBtnNext" onClick={nextSlide} />
                    <img className="wirefullScreenImage img-fluid" src={listaChicotes[slideNumber].img} alt="" />
                </div>
            }
            
            {/* LOGO */}
            <div className='img-custom-size img-fluid ms-2'>
                {/* Usando a variável definida pelo i18n */}
                <img src={logoByLanguage} alt='logoWireCapabilities'></img>
            </div>

            <div className="wireGalleryWrap mx-2">
                {
                    listaChicotes && listaChicotes.map((image, index) => {
                        return (
                            <div
                                className="wireSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="wires" />
                            </div>
                        )
                    })
                }
            </div>

            {/* BOTÃO VOLTAR */}
            <div className="text-center text-nowrap my-3">
                <Link to="/Capabilities/Production">
                    {/* Atualizei o texto hardcoded para usar a tradução do seu JSON */}
                    <button className="buttonCapabilities">
                        {t('productionCapabilities.backButton')}
                    </button>
                </Link>
            </div>
        </div >
    )
}

export default WireCapabilities